export const FETCH_CARER_STUDENTS = 'absences/FETCH_CARER_STUDENTS';
export const FETCH_CARER_STUDENTS_SUCCESS = 'absences/FETCH_CARER_STUDENTS_SUCCESS';
export const FETCH_ABSENCES = 'absences/FETCH_ABSENCES';
export const FETCH_ABSENCES_SUCCESS = 'absences/FETCH_ABSENCES_SUCCESS';
export const FETCH_ABSENCE_PERCENTAGE = 'absence/FETCH_ABSENCE_PERCENTAGE';
export const FETCH_ABSENCE_PERCENTAGE_SUCCESS = 'absences/FETCH_ABSENCE_PERCENTAGE_SUCCESS';
export const FETCH_STUDENT_INFO = "absence/FETCH_STUDENT_INFO";
export const FETCH_STUDENT_INFO_SUCCESS = "absence/FETCH_STUDENT_INFO_SUCCESS";
export const SEND_ABSENT_EMAIL = "absence/SEND_ABSENT_EMAIL";
export const SEND_ABSENT_EMAIL_SUCCESS = "absence/SEND_ABSENT_EMAIL_SUCCESS";
export const SAVE_ABSENCE_REASON = "absence/SAVE_ABSENCE_REASON";
export const SAVE_ABSENCE_REASON_SUCCESS = "absence/SAVE_ABSENCE_REASON_SUCCESS";
